import isNil from 'lodash/isNil';

import {
  FlagService,
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

export default {
  attachmentsEnabled: null,
  async init(): Promise<void> {
    const origin = StorageOfUniqueServices.get('WindowOriginService').origin;
    const response = await axios.get(
      origin + StorageOfUniqueServices.get('APIConstants').ATTACHMENTS_ENABLED
    );
    this.attachmentsEnabled = response.data;
  },

  areAttachmentsEnabled(): boolean {
    if (isNil(this.attachmentsEnabled)) {
      FlagService.createErrorFlag(
        'Error!',
        'AttachmentConfigService should be initialized before use'
      );
      return false;
    }

    return this.attachmentsEnabled;
  },
};
